import React, { useEffect, useRef } from 'react'
import { string } from 'prop-types'

function DangerouslySetHtmlContent({ html, ...rest }) {
  // eslint-disable-next-line react/react-in-jsx-scope
  return <div dangerouslySetInnerHTML={{ __html: html }} {...rest} />
}

DangerouslySetHtmlContent.propTypes = {
  html: string,
}

export default DangerouslySetHtmlContent
